import { render } from "./PrimeiraTela.vue?vue&type=template&id=4716fda0&ts=true"
import script from "./PrimeiraTela.vue?vue&type=script&lang=ts"
export * from "./PrimeiraTela.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/autoatendimento.totalvia.com.br/TotemAtendimento/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__